import React, { useState, useEffect } from "react";
import ImageGrid from "./ImageGrid";

const API = process.env.REACT_APP_API_URL || "";

function LatestWork({ excludedFolders, excludedImages }) {

  useEffect(() => {
    document.title = "All Work";
  }, []);

  const [hasError, setHasError] = useState(false);
  const [allImages, setAllImages] = useState([]);
  const [imageCount, setImageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const imageUrl = `${API}/allimages`;

  useEffect(() => {
    const fetchAllImages = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(imageUrl);

        if (!response.ok) {
          throw new Error("Failed to fetch images");
        }

        const data = await response.json();

        const images = data.images || [];

        const filteredImages = images
          .filter((item) => !excludedImages.includes(item.asset_id))
          .filter((item) => !excludedFolders.includes(item.asset_folder));

        setAllImages(filteredImages);
        setImageCount(data.totalCount || filteredImages.length);

      } catch (error) {
        console.error("Error fetching collection images:", error);
        setHasError(true);
      }

      setIsLoading(false);
    };

    fetchAllImages();
  }, [imageUrl, excludedImages, excludedFolders]);

  const latestWorkImages = allImages.slice(0, 8);

  if (isLoading) {
    return <div className="body-container">Loading...</div>;
  }

  if (hasError) {
    return <div className="body-container">Error loading images.</div>;
  }

  if (allImages.length === 0) {
    return <div className="body-container">No images found.</div>;
  }

  return (
    <div>
      <div className="body-container">
        <h1>Latest Work</h1>
      </div>

      <ImageGrid
        imageData={latestWorkImages}
        imageCount={imageCount}
        url={imageUrl}
        isAllWorkPage={true}
      />

    </div>
  );
}

export default LatestWork;